// extracted by mini-css-extract-plugin
module.exports = {"spot":"BlogSpot_spot__GEKlI","title":"BlogSpot_title__EbVQZ","description":"BlogSpot_description__p3cLy"};